import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { SessionInfo, SessionsListResponse } from "@/api/types";
import { assertCurrentSession, sessionRevision } from "@/lib/session-request-scope";

export function useRevokeSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (sessionId: string) => api.delete(`sessions/${sessionId}`).json<SessionInfo>(),
    onSuccess: async (_data, sessionId) => {
      const revision = sessionRevision();
      await queryClient.cancelQueries({ queryKey: ["sessions"], exact: true });
      assertCurrentSession(revision);
      queryClient.setQueryData<SessionsListResponse>(["sessions"], (data) =>
        data
          ? { ...data, sessions: data.sessions.filter((session) => session.id !== sessionId) }
          : data,
      );
      void queryClient.invalidateQueries({ queryKey: ["sessions"], exact: true });
    },
  });
}
